import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import T from 'shared/atoms/Typography';
import Dialog from 'shared/molecules/Dialog';
import theme from 'shared/themes/default';

import { usePlaylist } from '../../../context';

const PlaylistPublishDialogWrapper = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`;

const PublishDialog = () => {
  const { t } = useTranslation();

  const {
    dialogs: {
      // Share open variables
      openPublishDialog,
      // Dialog status
      formStatus,
      submittingPublish,
      // Publish dialog
      onPublish,
      onPublishCloseHandler,
    },
  } = usePlaylist();

  const dialogTitle = t('playlist.publishPlaylist');

  return (
    <Dialog
      ariaLabel={dialogTitle}
      open={openPublishDialog}
      actions={[
        {
          ariaLabel: t('generic.cancel'),
          handler: onPublishCloseHandler,
          label: t('generic.cancel'),
          type: 'secondaryOutline',
        },
        {
          ariaLabel: t('playlist.publish'),
          handler: onPublish,
          label: t('playlist.publish'),
        },
      ]}
      confirmationTitle={dialogTitle}
      formStatus={formStatus}
      loading={submittingPublish}
    >
      <PlaylistPublishDialogWrapper>
        <T
          fontWeight="semibold"
          align="center"
          component="span"
          color={theme.palette.mainDark}
        >
          {t('playlist.soonAvailable')}
        </T>
        <T align="center" component="span" color={theme.palette.mainDark}>
          {` ${t('playlist.contentChecked')}`}
        </T>
      </PlaylistPublishDialogWrapper>
    </Dialog>
  );
};

export default PublishDialog;
